// removed by extract-text-webpack-plugin
module.exports = {"Container":"about__Container__3FHuT","BackgroundContainer":"about__BackgroundContainer__18Yxu","Background":"about__Background__2m7WI","Tagline":"about__Tagline__2TbPz","Image":"about__Image__H0tl1","Content":"about__Content__2VVQL","Description":"about__Description__2YaWi","Link":"about__Link__2LRml"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/About/about.css
// module id = 1236
// module chunks = 2